import dayjs from 'dayjs';
import orderby from 'lodash.orderby';
import api from '../../api/index';
import ideas from './Activity_ideas';

export default {
  namespaced: true,
  modules   : {
    ideas,
  },
  state: {
    suggestions_themes: [
      {
        name: 'news',
        text: 'Новости',
      },
      {
        name: 'events',
        text: 'Мероприятия',
      },
    ],
    modals: [
      {
        type  : 'suggest_news',
        active: false,
      },
    ],
    suggestions: [
      {
        id   : 1,
        title: 'Решение проблемы хранения продукции…',
        date : 1543093200000,
        theme: 'Новость',
        text : 'Усовершенствован раздел «База знаний» на портале. Теперь можно скачивать материалы прямо на рабочий компьютер, телефон или планшет. Для регистрации на портале необходимо запросить логин/пароль у своего…',
      },
    ],
    selected_theme : null,
    selected_number: 10,
    selected_page  : 1,
    sorting        : 'asc',
  },
  getters: {
    suggestions    : ({suggestions}) => suggestions,
    selected_theme : ({selected_theme}) => selected_theme,
    selected_number: ({selected_number}) => selected_number,
    selected_page  : ({selected_page}) => selected_page,
    sorting        : ({sorting}) => sorting,
    filtered_by_theme({suggestions, selected_theme}) {
      if (selected_theme && selected_theme!='Все темы') {
        return suggestions.filter((item)=> item.theme == selected_theme);
      } else return suggestions;
    },
    search_suggestions: ({suggestions, selected_theme}, {filtered_by_theme}, rootState)=> {
      let search_string = rootState.activity.search_string;
      if (search_string) {
        if (selected_theme) {
          return filtered_by_theme.filter((x)=> x.title ? x.title.toLowerCase().includes(search_string.toLowerCase()) : x.text.toLowerCase().includes(search_string.toLowerCase()));
        } else {
          return suggestions.filter((x)=> x.title ? x.title.toLowerCase().includes(search_string.toLowerCase()) : x.text.toLowerCase().includes(search_string.toLowerCase()));
        }
      } else return suggestions;
    },
    paginated({selected_number, selected_page, sorting}, {filtered_by_theme, search_suggestions}, rootState) {
      let search_string = rootState.activity.search_string;
      let search_filtered = search_string ? search_suggestions : filtered_by_theme;
      let asc = orderby(search_filtered, (o) => o.date, 'asc');
      let desc = orderby(search_filtered, (o) => o.date, 'desc');
      if (sorting == 'asc') {
        return asc.slice((selected_number*(selected_page-1)), selected_number*selected_page);
      } else if (sorting == 'desc') {
        return desc.slice((selected_number*(selected_page-1)), selected_number*selected_page);
      } else {
        return search_filtered.slice((selected_number*(selected_page-1)), selected_number*selected_page);
      }
    },
  },
  mutations: {
    SET_ACTIVITY_SUGGESTIONS(state, value) {
      state.suggestions = value;
      state.suggestions.forEach((x)=> {
        x.date = x.date*1000;
      });
    },
    SET_SELECTED_THEME(state, value) {
      state.selected_theme = value;
    },
    SET_SELECTED_PAGE(state, value) {
      state.selected_page = value;
    },
    SHOW_NUMBER(state, obj) {
      const {array, selected} = obj;
      if (selected=='Показывать по 10') {
        state.selected_number = 10;
      } else if (selected=='Показывать по 25') {
        state.selected_number = 25;
      } else if (selected=='Показывать по 50') {
        state.selected_number = 50;
      } else if (selected=='Показывать по 100') {
        state.selected_number = 100;
      }
      if (array.length >= 10) {
        return array.slice(0, state.selected_number);
      } else {
        return array;
      }
    },
    SORT_BY_DATE(state, selected) {
      if (selected=='Сначала новые') {
        state.sorting = 'desc';
      } else if (selected=='Сначала старые') {
        state.sorting = 'asc';
      }
    },
    CLEAR_SUGGESTIONS_PAGES(state) {
      state.selected_page = 1;
    },
    // SEARCH_STRING(state, value) {
    //   state.search_string = value;
    //   state.selected_page = 1;
    // },
  },
  actions: {
    show_number({commit, getters}, event) {
      const {filtered_by_theme} = getters;
      commit('CLEAR_SUGGESTIONS_PAGES');
      commit('SHOW_NUMBER', {array: filtered_by_theme, selected: event});
    },
    sorting_by_date({commit}, selected) {
      commit('SORT_BY_DATE', selected);
      commit('CLEAR_SUGGESTIONS_PAGES');
    },
  },
};
